export const saveDialog = {
  title: "Zurück ohne Speichern?",
  text: "Du hast Änderungen vorgenommen. Möchtest du die Seite wirklich verlassen, ohne zu speichern?",
  close: "Ohne Speichern zurück",
  save: "Speichern und zurück"
};
